import Vue from 'vue';
import Router from 'vue-router';
import IndexRoutes from './routes/index.routes'
import NotFound from '../views/pages/404.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [...IndexRoutes, {
    path: '/:pathMatch(.*)*',
    component: NotFound
  }],
scrollBehavior(to, from, savedPosition){
	return { x: 0, y: 0 }
}
});

// router.beforeEach((to, from, next) => {
//   const publicPages = ['/login', '/register', '/home'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     next('/login');
//   } else {
//     next();
//   }
// });
